
import { reactive } from "vue";
import { defineComponent } from "vue";
import { qualityService } from "@/service";
import { useRoute, useRouter } from "vue-router";
import { RouterName } from "@/router";

export default defineComponent({
  setup() {
    const pageData: any = reactive({ list: [] });
    const route = useRoute();
    const router = useRouter();

    const getDetail = async () => {
      const { data } = await qualityService.pool_detail({ id: route.query.id, check_log: 1 });
      pageData.list = data.data.history_lists;
    };

    getDetail();

    const toDetail = (item: any, index: number) => {
      if (!index) return;
      router.push({
        name: RouterName.QUALITY_ABOUT_DETAIL,
        query: {
          id: route.query.id,
          recheck_num: item.recheck_num
        }
      });
    };

    return {
      pageData,
      toDetail
    };
  }
});
